<template>
  <main class="page about-page">
    <div class="page__body about-page__body">

      <div class="first-screen first-screen_bg _ibg first-screen_full">
        <img src="@/assets/img/about-bg.jpeg" alt="3oaks">
        <div class="_container">
          <!-- BREAD CRUMBS ============================================= -->
          <BreadCrumbs
              :links="[{title: 'About'}]"
          />
          <!-- BREAD CRUMBS ========================================= END -->

          <!-- PAGE DESCRIPTION ========================================= -->
          <div class="first-screen__body">
            <div class="first-screen__left">
              <div class="page-heading page-heading_colors">
                <h1>
                  <span>HI, WE ARE <em>3 OAKS GAMING!</em></span>
                </h1>
              </div>
              <div class="page-description page-description_offset _icon-arrow-2">
                <p>
                    3 Oaks is a distributor of premium player-favourite slots and promo tools from renowned high-value studios to licensed casino operators.
                </p>
              </div>
            </div>
            <div class="first-screen__right"></div>
          </div>
          <!-- PAGE DESCRIPTION ===================================== END -->
        </div>
      </div>

      <!-- VISION ======================================================= -->
      <section class="message-block offset-section">
        <div class="_container">
          <h6 class="vision-block">EXPERTISE, TEAMWORK & SOCIAL RESPONSIBILITY</h6>
          <div>
            We are a talented team with strategic ambitions, aiming to become the leading content distributor in the
            regulated iGaming industry. Our management team, with decades of expertise, has been driving our success
            since our establishment in 2021. We have fostered a dynamic and collaborative work environment where
            like-minded individuals thrive. With our unwavering dedication to quality entertainment and player safety,
            we approach our work with a deep sense of responsibility. We are committed to promoting responsible gaming
            through partnerships with licensed casino operators and esteemed gaming regulatory authorities.
          </div>
        </div>
      </section>
      <!-- VISION =================================================== END -->

      <!-- MOVE LINE ==================================================== -->
      <div class="about-page__move-lines">
        <MoveLine :title="'UNDER THE HOOD'" :slot-repeat=4>
          <span>SLOT GAMES</span>
          <span><img src="@/assets/img/svg/move-1.svg" alt="3oaks"></span>
          <span>GAME SERVER</span>
          <span><img src="@/assets/img/svg/move-2.svg" alt="3oaks"></span>
          <span>Backoffice</span>
          <span><img src="@/assets/img/svg/move-3.svg" alt="3oaks"></span>
        </MoveLine>
      </div>
      <!-- MOVE LINE ================================================ END -->

      <!-- SLOT GAMES BLOCK ============================================= -->
      <div class="slide-info-block">
        <div class="_container">
          <div class="slide-info-block__head">
            <h2>SLOT GAMES</h2>
          </div>
          <div class="slide-info-block__body">
            <div class="slide-info-block__slider-side">
              <img src="@/assets/img/info-slide-1.png" alt="3oaks">
            </div>
            <div class="slide-info-block__info">
              <div class="grid-container">
                <div class="grid-item">
                  <div class="head">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M3.33341 4.16667V15.8333H16.6667V4.16667H3.33341ZM2.50008 2.5H17.5001C17.7211 2.5 17.9331 2.5878 18.0893 2.74408C18.2456 2.90036 18.3334 3.11232 18.3334 3.33333V16.6667C18.3334 16.8877 18.2456 17.0996 18.0893 17.2559C17.9331 17.4122 17.7211 17.5 17.5001 17.5H2.50008C2.27907 17.5 2.06711 17.4122 1.91083 17.2559C1.75455 17.0996 1.66675 16.8877 1.66675 16.6667V3.33333C1.66675 3.11232 1.75455 2.90036 1.91083 2.74408C2.06711 2.5878 2.27907 2.5 2.50008 2.5V2.5ZM6.25008 9.375H7.91675V7.5H9.16675V12.5H7.91675V10.625H6.25008V12.5H5.00008V7.5H6.25008V9.375ZM12.0834 8.75V11.25H13.3334C13.4439 11.25 13.5499 11.2061 13.628 11.128C13.7062 11.0498 13.7501 10.9438 13.7501 10.8333V9.16667C13.7501 9.05616 13.7062 8.95018 13.628 8.87204C13.5499 8.7939 13.4439 8.75 13.3334 8.75H12.0834ZM10.8334 7.5H13.3334C13.7754 7.5 14.1994 7.67559 14.5119 7.98816C14.8245 8.30072 15.0001 8.72464 15.0001 9.16667V10.8333C15.0001 11.2754 14.8245 11.6993 14.5119 12.0118C14.1994 12.3244 13.7754 12.5 13.3334 12.5H10.8334V7.5Z"
                            fill="url(#paint0_linear_823:6592)"/>
                      <defs>
                        <linearGradient id="paint0_linear_823:6592"
                                        x1="15.4825" y1="3.08812"
                                        x2="6.11243" y2="17.7092"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                      </defs>
                    </svg>
                    <span>STUNNING 2D & 3D GRAPHICS</span>
                  </div>
                  <div class="body">
                    <p>
                      Generate higher profits on greater players’ excitement
                    </p>
                  </div>
                </div>

                <div class="grid-item">
                  <div class="head">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M3.3332 13.3333H16.6665V4.16667H3.3332V13.3333ZM10.8332 15V16.6667H14.1665V18.3333H5.8332V16.6667H9.16654V15H2.4932C2.38378 14.9993 2.27555 14.9771 2.17474 14.9345C2.07392 14.892 1.98249 14.83 1.9057 14.752C1.8289 14.674 1.76824 14.5817 1.72721 14.4802C1.68617 14.3788 1.66555 14.2703 1.66654 14.1608V3.33917C1.66654 2.87583 2.0457 2.5 2.4932 2.5H17.5065C17.9632 2.5 18.3332 2.87417 18.3332 3.33917V14.1608C18.3332 14.6242 17.954 15 17.5065 15H10.8332V15Z"
                            fill="url(#paint0_linear_1701:4274)"/>
                      <defs>
                        <linearGradient id="paint0_linear_1701:4274"
                                        x1="15.4823" y1="3.12079"
                                        x2="5.37811" y2="18.0576"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                      </defs>
                    </svg>
                    <span>FULLY MOBILE AND TABLET ADAPTIVE</span>
                  </div>
                  <div class="body">
                    <p>Reach out to you players whenever, wherever</p>
                  </div>
                </div>

                <div class="grid-item">
                  <div class="head">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M4.66333 4.16659L8.75 9.10659L12.8367 4.16659H15L9.83167 10.4141L15 16.6616V16.6666H12.8417L8.75 11.7216L4.65833 16.6666H2.5V16.6616L7.66833 10.4141L2.5 4.16659H4.66333ZM17.9583 5.48325C18.0441 5.40184 18.1066 5.29908 18.1395 5.18553C18.1725 5.07198 18.1746 4.95171 18.1458 4.83705C18.1169 4.7224 18.0581 4.61748 17.9753 4.53306C17.8925 4.44864 17.7887 4.38776 17.6747 4.35665C17.5606 4.32554 17.4403 4.32532 17.3261 4.35603C17.212 4.38673 17.108 4.44725 17.0249 4.53137C16.9418 4.61549 16.8826 4.7202 16.8534 4.83475C16.8241 4.9493 16.8258 5.06958 16.8583 5.18325L15.8958 5.45825C15.825 5.21006 15.8128 4.94881 15.8601 4.69508C15.9074 4.44136 16.013 4.20208 16.1685 3.99608C16.324 3.79009 16.5252 3.623 16.7562 3.50798C16.9873 3.39296 17.2419 3.33315 17.5 3.33325C17.8337 3.3333 18.1596 3.4335 18.4357 3.62088C18.7118 3.80826 18.9253 4.07419 19.0486 4.38426C19.1718 4.69433 19.1992 5.03426 19.1271 5.36004C19.055 5.68583 18.8867 5.98248 18.6442 6.21159L17.2867 7.49992H19.1667V8.33325H15.8333V7.49992L17.9583 5.48325Z"
                            fill="url(#paint0_linear_1701:4164)"/>
                      <defs>
                        <linearGradient id="paint0_linear_1701:4164"
                                        x1="16.3158" y1="3.85603"
                                        x2="8.43043" y2="17.6983"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                      </defs>
                    </svg>
                    <span>TOP PERFORMING MATH MODELS</span>
                  </div>
                  <div class="body">
                    <p>Keep players’ excitement while yielding income</p>
                  </div>
                </div>

                <div class="grid-item">
                  <div class="head">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M4.16675 12.5001V14.1667C4.16662 14.5872 4.32542 14.9922 4.61133 15.3005C4.89724 15.6089 5.28912 15.7977 5.70841 15.8292L5.83341 15.8334H8.33342V17.5001H5.83341C4.94936 17.5001 4.10151 17.1489 3.47639 16.5238C2.85127 15.8986 2.50008 15.0508 2.50008 14.1667V12.5001H4.16675ZM15.0001 8.33341L18.6667 17.5001H16.8709L15.8701 15.0001H12.4617L11.4626 17.5001H9.66758L13.3334 8.33341H15.0001ZM14.1667 10.7376L13.1276 13.3334H15.2042L14.1667 10.7376ZM6.66675 1.66675V3.33341H10.0001V9.16675H6.66675V11.6667H5.00008V9.16675H1.66675V3.33341H5.00008V1.66675H6.66675ZM14.1667 2.50008C15.0508 2.50008 15.8986 2.85127 16.5238 3.47639C17.1489 4.10151 17.5001 4.94936 17.5001 5.83341V7.50008H15.8334V5.83341C15.8334 5.39139 15.6578 4.96746 15.3453 4.6549C15.0327 4.34234 14.6088 4.16675 14.1667 4.16675H11.6667V2.50008H14.1667ZM5.00008 5.00008H3.33341V7.50008H5.00008V5.00008ZM8.33342 5.00008H6.66675V7.50008H8.33342V5.00008Z"
                            fill="url(#paint0_linear_1701:4283)"/>
                      <defs>
                        <linearGradient id="paint0_linear_1701:4283"
                                        x1="15.7588" y1="2.28754"
                                        x2="5.73051" y2="17.4086"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                      </defs>
                    </svg>
                    <span>AVAILABLE IN 19 LANGUAGES</span>
                  </div>
                  <div class="body">
                    <p>Adding any new language just in 2 weeks</p>
                  </div>
                </div>

                <div class="grid-item">
                  <div class="head">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M15.751 8.33333C16.0802 8.90463 16.6218 9.32269 17.2579 9.49642C17.8939 9.67014 18.5729 9.58547 19.1468 9.26083C19.2143 9.86387 19.092 10.473 18.797 11.0032C18.502 11.5335 18.0489 11.9585 17.501 12.2192L17.5001 17.5H11.6668V15.8333C11.6669 15.4129 11.5081 15.0079 11.2222 14.6995C10.9363 14.3912 10.5444 14.2024 10.1251 14.1708L10.0001 14.1667C9.57965 14.1665 9.17466 14.3253 8.86634 14.6112C8.55802 14.8972 8.36916 15.289 8.33763 15.7083L8.33346 15.8333V17.5H2.50013V12.22C1.95108 11.9597 1.49703 11.5345 1.20137 11.0037C0.905704 10.4729 0.7832 9.86298 0.850961 9.25917C1.42482 9.58446 2.10402 9.66969 2.74047 9.49625C3.37691 9.32282 3.91897 8.9048 4.24846 8.33333H15.751ZM14.9418 10H5.05763L4.99429 10.0658C4.63513 10.4158 4.21513 10.6992 3.75596 10.9008L3.67596 10.9333L4.16679 11.1667L4.16596 15.8333L6.66763 15.8325V15.7725L6.67596 15.5867C6.80013 13.9067 8.15929 12.5875 9.88763 12.505L10.061 12.5008L10.2468 12.5092C11.0569 12.5693 11.8172 12.9231 12.3848 13.5042C12.9524 14.0853 13.2883 14.8537 13.3293 15.665L13.3326 15.8325L15.8335 15.8333L15.8343 11.1667L16.3235 10.9333L16.2443 10.9C15.7847 10.6987 15.3652 10.4162 15.006 10.0658L14.9418 10ZM14.1968 2.5C14.2564 2.91342 14.4041 3.30921 14.6299 3.6606C14.8557 4.01199 15.1544 4.31077 15.5057 4.53675C15.857 4.76272 16.2527 4.91061 16.6661 4.9704C17.0795 5.0302 17.5009 5.0005 17.9018 4.88333C17.8304 5.57381 17.5152 6.21621 17.0126 6.69507C16.5101 7.17393 15.8532 7.45786 15.1601 7.49583L15.0001 7.5H5.00013C4.27844 7.50012 3.58233 7.23267 3.04638 6.74936C2.51043 6.26604 2.17269 5.60119 2.09846 4.88333C2.49938 5.0005 2.92079 5.0302 3.33418 4.9704C3.74757 4.91061 4.14329 4.76272 4.49458 4.53675C4.84587 4.31077 5.14452 4.01199 5.37033 3.6606C5.59615 3.30921 5.74385 2.91342 5.80346 2.5H14.1968ZM13.0001 4.16667H6.99929C6.69906 4.75454 6.27554 5.27073 5.75763 5.68L5.55096 5.83333H14.4485L14.4385 5.82667C13.9025 5.44774 13.4538 4.95844 13.1226 4.39167L13.0001 4.16667Z"
                            fill="url(#paint0_linear_1701:4310)"/>
                      <defs>
                        <linearGradient id="paint0_linear_1701:4310"
                                        x1="16.0291" y1="3.08812"
                                        x2="7.05725" y2="18.4868"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                      </defs>
                    </svg>
                    <span>ASIAN & WESTERN THEMES</span>
                  </div>
                  <div class="body">
                    <p>Variety of cultural theme designs</p>
                  </div>
                </div>

                <div class="grid-item">
                  <div class="head">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M10.0001 1.66675C14.6026 1.66675 18.3334 5.39758 18.3334 10.0001C18.3334 14.6026 14.6026 18.3334 10.0001 18.3334C5.39758 18.3334 1.66675 14.6026 1.66675 10.0001C1.66675 5.39758 5.39758 1.66675 10.0001 1.66675ZM10.0001 3.33341C8.23197 3.33341 6.53628 4.03579 5.28604 5.28604C4.03579 6.53628 3.33341 8.23197 3.33341 10.0001C3.33341 11.7682 4.03579 13.4639 5.28604 14.7141C6.53628 15.9644 8.23197 16.6667 10.0001 16.6667C11.7682 16.6667 13.4639 15.9644 14.7141 14.7141C15.9644 13.4639 16.6667 11.7682 16.6667 10.0001C16.6667 8.23197 15.9644 6.53628 14.7141 5.28604C13.4639 4.03579 11.7682 3.33341 10.0001 3.33341V3.33341ZM10.0001 5.83341C10.8772 5.83375 11.7319 6.11089 12.4424 6.62536C13.1528 7.13984 13.6827 7.86539 13.9567 8.69866C14.2307 9.53194 14.2347 10.4304 13.9682 11.2661C13.7017 12.1018 13.1782 12.832 12.4724 13.3528C11.7666 13.8736 10.9144 14.1584 10.0373 14.1666C9.16017 14.1747 8.30285 13.9059 7.58746 13.3983C6.87208 12.8908 6.33512 12.1704 6.05309 11.3398C5.77105 10.5092 5.75834 9.61081 6.01675 8.77258C6.21168 9.20818 6.55031 9.5636 6.97596 9.77938C7.40161 9.99516 7.88846 10.0582 8.35504 9.95796C8.82161 9.85772 9.2396 9.60027 9.53906 9.22869C9.83852 8.85712 10.0013 8.39397 10.0001 7.91675C10.0002 7.51547 9.88441 7.1227 9.66666 6.78564C9.4489 6.44859 9.13844 6.18159 8.77258 6.01675C9.16092 5.89758 9.57258 5.83341 10.0001 5.83341V5.83341Z"
                            fill="url(#paint0_linear_1701:4260)"/>
                      <defs>
                        <linearGradient id="paint0_linear_1701:4260"
                                        x1="15.4825" y1="2.32022"
                                        x2="4.654" y2="17.5273"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                      </defs>
                    </svg>
                    <span>CROSS PLATFORM / MOBILE ADAPTIVE</span>
                  </div>
                  <div class="body">
                    <p>Exceptional performance</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- SLOT GAMES BLOCK ========================================= END -->

      <!-- RGS BLOCK ==================================================== -->
      <div class="slide-info-block">
        <div class="_container">
          <div class="slide-info-block__head">
            <h2>GAME SERVER</h2>
          </div>
          <div class="slide-info-block__body slide-info-block__body_reverse">
            <div class="slide-info-block__slider-side">
              <img src="@/assets/img/info-slide-2.png" alt="3oaks">
            </div>
            <div class="slide-info-block__info">
              <div class="grid-container">
                <div class="grid-item">
                  <div class="head">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M10 0.833374L16.8475 2.35504C17.2283 2.44004 17.5 2.77754 17.5 3.16837V11.4909C17.5 13.1625 16.6642 14.7242 15.2733 15.6509L10 19.1667L4.72667 15.6509C3.335 14.7234 2.5 13.1625 2.5 11.4917V3.16837C2.5 2.77754 2.77167 2.44004 3.1525 2.35504L10 0.833374ZM10 2.54087L4.16667 3.83671V11.4909C4.16667 12.605 4.72333 13.6459 5.65083 14.2642L10 17.1642L14.3492 14.2642C15.2767 13.6459 15.8333 12.6059 15.8333 11.4917V3.83671L10 2.54171V2.54087ZM13.71 6.85171L14.8892 8.03004L9.58583 13.3334L6.05 9.79754L7.22833 8.61921L9.585 10.9759L13.71 6.85087V6.85171Z"
                            fill="url(#paint0_linear_1701:4321)"/>
                      <defs>
                        <linearGradient id="paint0_linear_1701:4321"
                                        x1="14.9342" y1="1.55219"
                                        x2="2.45005" y2="15.8967"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                      </defs>
                    </svg>
                    <span>ROBUST & RELIABLE</span>
                  </div>
                  <div class="body">
                    <p>
                      Steady, secure & hassle free operation are guaranteed
                      365/24/7
                    </p>
                  </div>
                </div>

                <div class="grid-item">
                  <div class="head">
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none"
                         xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M16.9036 11.0371H18.6295C18.9261 11.0371 19.1666 10.7967 19.1666 10.5V5.32231C19.1666 5.02568 18.9261 4.7852 18.6295 4.7852H13.9888V3.59639C13.9888 2.34855 12.9736 1.33337 11.7258 1.33337C10.478 1.33337 9.46281 2.34858 9.46281 3.59639V4.7852H4.82218C4.52556 4.7852 4.28507 5.02568 4.28507 5.32231V9.96293H3.09627C1.84846 9.96293 0.833252 10.9781 0.833252 12.226C0.833252 13.4738 1.84846 14.489 3.09627 14.489H4.28507V19.1296C4.28507 19.4262 4.52556 19.6667 4.82218 19.6667H9.99992C10.2965 19.6667 10.537 19.4262 10.537 19.1296V17.4037C10.537 16.7482 11.0703 16.2149 11.7258 16.2149C12.3813 16.2149 12.9146 16.7482 12.9146 17.4037V19.1296C12.9146 19.4262 13.1551 19.6667 13.4517 19.6667H18.6295C18.9261 19.6667 19.1666 19.4262 19.1666 19.1296V13.9519C19.1666 13.6552 18.9261 13.4148 18.6295 13.4148H16.9036C16.248 13.4148 15.7148 12.8814 15.7148 12.226C15.7148 11.5705 16.248 11.0371 16.9036 11.0371ZM16.9036 14.489H18.0924V18.5925H13.9888V17.4037C13.9888 16.1558 12.9736 15.1407 11.7258 15.1407C10.478 15.1407 9.46281 16.1558 9.46281 17.4037V18.5925H5.35929V13.9519C5.35929 13.6552 5.11881 13.4148 4.82218 13.4148H3.09627C2.44075 13.4148 1.90747 12.8814 1.90747 12.226C1.90747 11.5705 2.44078 11.0371 3.09627 11.0371H4.82218C5.11881 11.0371 5.35929 10.7967 5.35929 10.5V5.85942H9.99992C10.2965 5.85942 10.537 5.61893 10.537 5.32231V3.59639C10.537 2.94087 11.0703 2.40759 11.7258 2.40759C12.3813 2.40759 12.9146 2.94091 12.9146 3.59639V5.32231C12.9146 5.61893 13.1551 5.85942 13.4517 5.85942H18.0924V9.96293H16.9036C15.6557 9.96293 14.6405 10.9781 14.6405 12.226C14.6405 13.4738 15.6557 14.489 16.9036 14.489Z"
                            fill="url(#paint0_linear_1701:4359)"
                            stroke="url(#paint1_linear_1701:4359)"
                            stroke-width="0.6"/>
                      <defs>
                        <linearGradient id="paint0_linear_1701:4359"
                                        x1="16.0306" y1="2.05219"
                                        x2="4.11922" y2="18.78"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                        <linearGradient id="paint1_linear_1701:4359"
                                        x1="16.0306" y1="2.05219"
                                        x2="4.11922" y2="18.78"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                      </defs>
                    </svg>
                    <span>SEAMLESS INTEGRATION</span>
                  </div>
                  <div class="body">
                    <p>Simple API with automatic integration testing</p>
                  </div>
                </div>

                <div class="grid-item">
                  <div class="head">
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none"
                         xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M5.92095 7.82494C6.0655 8.35397 6.37995 8.82082 6.81587 9.15359C7.2518 9.48637 7.78502 9.66663 8.33345 9.6666H11.6668C12.6485 9.66668 13.5986 10.0133 14.3498 10.6454C15.1009 11.2774 15.6048 12.1544 15.7726 13.1216C16.3382 13.3061 16.8195 13.6862 17.13 14.1937C17.4406 14.7011 17.5601 15.3026 17.467 15.8902C17.374 16.4779 17.0745 17.013 16.6223 17.3997C16.1702 17.7864 15.595 17.9992 15.0001 17.9999C14.4181 18.0004 13.8541 17.7977 13.4054 17.4269C12.9568 17.0561 12.6516 16.5403 12.5425 15.9686C12.4334 15.3969 12.5272 14.805 12.8077 14.295C13.0883 13.785 13.538 13.3889 14.0793 13.1749C13.9347 12.6459 13.6203 12.1791 13.1844 11.8463C12.7484 11.5135 12.2152 11.3332 11.6668 11.3333H8.33345C7.43169 11.3346 6.55406 11.0421 5.83345 10.4999V13.1416C6.38969 13.3382 6.85853 13.7251 7.15708 14.2339C7.45564 14.7428 7.56469 15.3408 7.46496 15.9223C7.36523 16.5037 7.06314 17.0312 6.61209 17.4115C6.16104 17.7918 5.59008 18.0003 5.00012 18.0003C4.41016 18.0003 3.83919 17.7918 3.38814 17.4115C2.93709 17.0312 2.635 16.5037 2.53528 15.9223C2.43555 15.3408 2.5446 14.7428 2.84315 14.2339C3.14171 13.7251 3.61054 13.3382 4.16678 13.1416V7.85827C3.61426 7.66319 3.14778 7.2803 2.84874 6.77641C2.54971 6.27252 2.43709 5.67962 2.53056 5.10118C2.62403 4.52273 2.91764 3.99547 3.36017 3.61141C3.80269 3.22734 4.36602 3.01085 4.95186 2.99972C5.5377 2.98859 6.10885 3.18352 6.56564 3.5505C7.02244 3.91747 7.33587 4.4332 7.45125 5.00767C7.56662 5.58215 7.47662 6.17889 7.19694 6.69378C6.91726 7.20867 6.46566 7.60901 5.92095 7.82494ZM5.00012 6.33327C5.22113 6.33327 5.43309 6.24547 5.58937 6.08919C5.74565 5.93291 5.83345 5.72095 5.83345 5.49994C5.83345 5.27892 5.74565 5.06696 5.58937 4.91068C5.43309 4.7544 5.22113 4.6666 5.00012 4.6666C4.7791 4.6666 4.56714 4.7544 4.41086 4.91068C4.25458 5.06696 4.16678 5.27892 4.16678 5.49994C4.16678 5.72095 4.25458 5.93291 4.41086 6.08919C4.56714 6.24547 4.7791 6.33327 5.00012 6.33327ZM5.00012 16.3333C5.22113 16.3333 5.43309 16.2455 5.58937 16.0892C5.74565 15.9329 5.83345 15.721 5.83345 15.4999C5.83345 15.2789 5.74565 15.067 5.58937 14.9107C5.43309 14.7544 5.22113 14.6666 5.00012 14.6666C4.7791 14.6666 4.56714 14.7544 4.41086 14.9107C4.25458 15.067 4.16678 15.2789 4.16678 15.4999C4.16678 15.721 4.25458 15.9329 4.41086 16.0892C4.56714 16.2455 4.7791 16.3333 5.00012 16.3333ZM15.0001 16.3333C15.2211 16.3333 15.4331 16.2455 15.5894 16.0892C15.7457 15.9329 15.8335 15.721 15.8335 15.4999C15.8335 15.2789 15.7457 15.067 15.5894 14.9107C15.4331 14.7544 15.2211 14.6666 15.0001 14.6666C14.7791 14.6666 14.5671 14.7544 14.4109 14.9107C14.2546 15.067 14.1668 15.2789 14.1668 15.4999C14.1668 15.721 14.2546 15.9329 14.4109 16.0892C14.5671 16.2455 14.7791 16.3333 15.0001 16.3333Z"
                            fill="url(#paint0_linear_1701:4334)"/>
                      <defs>
                        <linearGradient id="paint0_linear_1701:4334"
                                        x1="14.9321" y1="3.58743"
                                        x2="5.18536" y2="17.2737"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                      </defs>
                    </svg>
                    <span>FLEXIBLE ARCHITECTURE</span>
                  </div>
                  <div class="body">
                    <p>Instant inclusion of requested features in no time</p>
                  </div>
                </div>

                <div class="grid-item">
                  <div class="head">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M0.833252 17.3004H2.21726V12.1245H3.2273L4.46748 17.3004H5.99532L4.60492 11.6255C5.34966 10.9125 5.76199 9.4653 5.76199 7.46911C5.76199 4.56749 4.90218 2.69962 3.41588 2.69962H0.833252V17.3004ZM2.21726 9.64354V5.22338H3.15059C3.94967 5.22338 4.33643 6.01473 4.33643 7.46911C4.33643 8.91635 3.94967 9.64354 3.15698 9.64354H2.21726Z"
                            fill="url(#paint0_linear_1701:5248)"/>
                      <path d="M12.2154 2.69962H10.8378V11.8821H10.7802L7.95467 2.69962H6.74006V17.3004H8.12407V8.11074H8.17202L11.0199 17.3004H12.2154V2.69962Z"
                            fill="url(#paint1_linear_1701:5248)"/>
                      <path d="M17.6995 7.4192H19.1059C18.9269 4.53184 17.7858 2.5 16.3059 2.5C14.5767 2.5 13.2438 5.28042 13.2438 10.0143C13.2438 14.634 14.4904 17.5 16.3346 17.5C17.9871 17.5 19.1666 15.1687 19.1666 11.326V9.48669H16.4273V11.8108H17.8337C17.8145 13.6217 17.2616 14.7695 16.341 14.7695C15.3022 14.7695 14.647 13.0371 14.647 9.98574C14.647 6.94867 15.3278 5.23051 16.3282 5.23051C17.041 5.23051 17.5237 6.05038 17.6995 7.4192Z"
                            fill="url(#paint2_linear_1701:5248)"/>
                      <defs>
                        <linearGradient id="paint0_linear_1701:5248"
                                        x1="16.0306" y1="3.08812"
                                        x2="7.05903" y2="18.4873"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                        <linearGradient id="paint1_linear_1701:5248"
                                        x1="16.0306" y1="3.08812"
                                        x2="7.05903" y2="18.4873"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                        <linearGradient id="paint2_linear_1701:5248"
                                        x1="16.0306" y1="3.08812"
                                        x2="7.05903" y2="18.4873"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                      </defs>
                    </svg>
                    <span>INDUSTRY COMPLIANT</span>
                  </div>
                  <div class="body">
                    <p>
                      RNG tested & certified, compliant to most industry
                      requirements
                    </p>
                  </div>
                </div>

                <div class="grid-item">
                  <div class="head">
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none"
                         xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M10.0001 18.8333C5.39758 18.8333 1.66675 15.1025 1.66675 10.5C1.66675 5.89746 5.39758 2.16663 10.0001 2.16663C14.6026 2.16663 18.3334 5.89746 18.3334 10.5C18.3334 15.1025 14.6026 18.8333 10.0001 18.8333ZM8.09175 16.8891C7.26959 15.1452 6.79331 13.2585 6.68925 11.3333H3.38508C3.54724 12.6157 4.07835 13.8234 4.91389 14.8097C5.74943 15.796 6.85343 16.5184 8.09175 16.8891V16.8891ZM8.35841 11.3333C8.48425 13.3658 9.06508 15.275 10.0001 16.96C10.9603 15.2304 11.5213 13.3079 11.6417 11.3333H8.35841V11.3333ZM16.6151 11.3333H13.3109C13.2069 13.2585 12.7306 15.1452 11.9084 16.8891C13.1467 16.5184 14.2507 15.796 15.0863 14.8097C15.9218 13.8234 16.4529 12.6157 16.6151 11.3333V11.3333ZM3.38508 9.66663H6.68925C6.79331 7.74145 7.26959 5.8547 8.09175 4.11079C6.85343 4.48153 5.74943 5.20392 4.91389 6.19021C4.07835 7.17649 3.54724 8.38421 3.38508 9.66663V9.66663ZM8.35925 9.66663H11.6409C11.5207 7.69213 10.9601 5.76957 10.0001 4.03996C9.03982 5.7695 8.47888 7.69206 8.35841 9.66663H8.35925ZM11.9084 4.11079C12.7306 5.8547 13.2069 7.74145 13.3109 9.66663H16.6151C16.4529 8.38421 15.9218 7.17649 15.0863 6.19021C14.2507 5.20392 13.1467 4.48153 11.9084 4.11079V4.11079Z"
                            fill="url(#paint0_linear_1701:4347)"/>
                      <defs>
                        <linearGradient id="paint0_linear_1701:4347"
                                        x1="15.4825" y1="2.82009"
                                        x2="4.654" y2="18.0272"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                      </defs>
                    </svg>
                    <span>ACCESSIBLE WORLDWIDE</span>
                  </div>
                  <div class="body">
                    <p>Flawless performance in any region over the globe</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- RGS BLOCK ================================================ END -->

      <!-- BACKOFFICE BLOCK ============================================= -->
      <div class="slide-info-block">
        <div class="_container">
          <div class="slide-info-block__head">
            <h2>BACKOFFICE</h2>
          </div>
          <div class="slide-info-block__body">
            <div class="slide-info-block__slider-side">
              <img src="@/assets/img/info-slide-3.png" alt="3oaks">
            </div>
            <div class="slide-info-block__info">
              <div class="grid-container">
                <div class="grid-item">
                  <div class="head">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M11.6666 11.8766V13.6183C10.9124 13.3517 10.1051 13.2699 9.31276 13.3798C8.52036 13.4897 7.76592 13.7882 7.11278 14.2502C6.45964 14.7121 5.92687 15.324 5.55922 16.0345C5.19157 16.745 4.99977 17.5333 4.99992 18.3333L3.33325 18.3325C3.33299 17.3149 3.56569 16.3107 4.0135 15.397C4.46132 14.4832 5.11237 13.6841 5.91677 13.0608C6.72117 12.4376 7.65757 12.0068 8.65421 11.8014C9.65086 11.5959 10.6813 11.6222 11.6666 11.8766ZM9.99992 10.8333C7.23742 10.8333 4.99992 8.59581 4.99992 5.83331C4.99992 3.07081 7.23742 0.833313 9.99992 0.833313C12.7624 0.833313 14.9999 3.07081 14.9999 5.83331C14.9999 8.59581 12.7624 10.8333 9.99992 10.8333ZM9.99992 9.16665C11.8416 9.16665 13.3333 7.67498 13.3333 5.83331C13.3333 3.99165 11.8416 2.49998 9.99992 2.49998C8.15825 2.49998 6.66659 3.99165 6.66659 5.83331C6.66659 7.67498 8.15825 9.16665 9.99992 9.16665Z"
                            fill="url(#paint0_linear_1701:4152)"/>
                      <line x1="13.5" y1="14.1667" x2="13.5" y2="18.3334"
                            stroke="url(#paint1_linear_1701:4152)"
                            stroke-width="2"/>
                      <line x1="16" y1="10.8333" x2="16" y2="18.3333"
                            stroke="url(#paint2_linear_1701:4152)"
                            stroke-width="2"/>
                      <line x1="18.5" y1="13.3333" x2="18.5" y2="18.3333"
                            stroke="url(#paint3_linear_1701:4152)"
                            stroke-width="2"/>
                      <defs>
                        <linearGradient id="paint0_linear_1701:4152"
                                        x1="13.0043" y1="1.51945"
                                        x2="0.998522" y2="12.7597"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                        <linearGradient id="paint1_linear_1701:4152"
                                        x1="12.4608" y1="17.6206"
                                        x2="11.1247" y2="17.3923"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                        <linearGradient id="paint2_linear_1701:4152"
                                        x1="14.9608" y1="17.0504"
                                        x2="13.598" y2="16.921"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                        <linearGradient id="paint3_linear_1701:4152"
                                        x1="17.4608" y1="17.478"
                                        x2="16.1131" y2="17.2861"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                      </defs>
                    </svg>
                    <span>GAMES MANAGEMENT AND PLAYERS SUPPORT</span>
                  </div>
                  <div class="body">
                    <p>
                      Live troubleshooting & full suite of settings at
                      your fingertips
                    </p>
                  </div>
                </div>

                <div class="grid-item">
                  <div class="head">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M1.66675 10.8333H5.83341V17.5H1.66675V10.8333ZM7.50008 5.83329H11.6667V17.5H7.50008V5.83329ZM13.3334 1.66663H17.5001V17.5H13.3334V1.66663Z"
                            fill="url(#paint0_linear_1701:4143)"/>
                      <defs>
                        <linearGradient id="paint0_linear_1701:4143"
                                        x1="14.7917" y1="2.28742"
                                        x2="4.50463" y2="16.7342"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                      </defs>
                    </svg>
                    <span>REAL-TIME DATA & ANALYTICS</span>
                  </div>
                  <div class="body">
                    <p>
                      Ease & precise reporting with indepth analysis of
                      players’ activity
                    </p>
                  </div>
                </div>

                <div class="grid-item">
                  <div class="head">
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none"
                         xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M10.1003 3V12.338C10.1003 14.0279 9.33109 15.2484 8.14906 15.2484C6.97172 15.2484 6.19777 14.0279 6.19777 12.338V3H4.16675V12.6052C4.16675 15.8406 5.75217 18 8.14906 18C10.5366 18 12.1314 15.8406 12.1314 12.6052V3H10.1003Z"
                            fill="url(#paint0_linear_1701:5200)"/>
                      <path d="M15.8334 3H13.8024V17.7906H15.8334V3Z"
                            fill="url(#paint1_linear_1701:5200)"/>
                      <defs>
                        <linearGradient id="paint0_linear_1701:5200"
                                        x1="13.8378" y1="3.58812"
                                        x2="3.56483" y2="14.8091"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                        <linearGradient id="paint1_linear_1701:5200"
                                        x1="13.8378" y1="3.58812"
                                        x2="3.56483" y2="14.8091"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                      </defs>
                    </svg>
                    <span>EXCEPTIONAL UI / UX</span>
                  </div>
                  <div class="body">
                    <p>Optimized user interfaces and flawless navigation</p>
                  </div>
                </div>

                <div class="grid-item">
                  <div class="head">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.4999 1.66663C13.0852 1.66656 13.6601 1.82057 14.1669 2.11318C14.6738 2.40579 15.0946 2.82669 15.3872 3.33354C15.6798 3.8404 15.8338 4.41535 15.8336 5.00059C15.8335 5.58582 15.6793 6.16072 15.3866 6.66746L19.1666 6.66663V8.3333H17.4999V16.6666C17.4999 16.8876 17.4121 17.0996 17.2558 17.2559C17.0996 17.4122 16.8876 17.5 16.6666 17.5H3.33325C3.11224 17.5 2.90028 17.4122 2.744 17.2559C2.58772 17.0996 2.49992 16.8876 2.49992 16.6666V8.3333H0.833252V6.66663L4.61325 6.66746C4.1998 5.95154 4.06716 5.10751 4.24107 4.29928C4.41498 3.49104 4.88304 2.77627 5.55436 2.29376C6.22569 1.81125 7.05236 1.59542 7.87388 1.6882C8.69539 1.78097 9.45311 2.17572 9.99992 2.7958C10.3121 2.44028 10.6966 2.15561 11.1278 1.96086C11.559 1.76612 12.0268 1.6658 12.4999 1.66663V1.66663ZM9.16658 8.3333H4.16658V15.8333H9.16658V8.3333ZM15.8333 8.3333H10.8333V15.8333H15.8333V8.3333ZM7.49992 3.3333C7.06743 3.33136 6.65113 3.49762 6.33896 3.79695C6.02679 4.09627 5.84319 4.50523 5.82697 4.93741C5.81074 5.3696 5.96315 5.79117 6.25199 6.11306C6.54084 6.43496 6.94351 6.63196 7.37492 6.66246L7.49992 6.66663H9.16658V4.99996C9.1666 4.60168 9.02399 4.21656 8.76458 3.91435C8.50516 3.61213 8.1461 3.4128 7.75242 3.35246L7.62408 3.33746L7.49992 3.3333ZM12.4999 3.3333C12.0794 3.33316 11.6744 3.49197 11.3661 3.77788C11.0578 4.06379 10.869 4.45567 10.8374 4.87496L10.8333 4.99996V6.66663H12.4999C12.9204 6.66676 13.3254 6.50796 13.6337 6.22205C13.942 5.93614 14.1309 5.54426 14.1624 5.12496L14.1666 4.99996C14.1666 4.55794 13.991 4.13401 13.6784 3.82145C13.3659 3.50889 12.9419 3.3333 12.4999 3.3333V3.3333Z"
                            fill="url(#paint0_linear_1701:4173)"/>
                      <defs>
                        <linearGradient id="paint0_linear_1701:4173"
                                        x1="16.0306" y1="2.28742"
                                        x2="6.31563" y2="18.0849"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                      </defs>
                    </svg>
                    <span>PROMO MANAGEMENT</span>
                  </div>
                  <div class="body">
                    <p>
                      Keep engagement at the highest level for a maximum
                      player retention rates and LTV
                    </p>
                  </div>
                </div>

                <div class="grid-item">
                  <div class="head">
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none"
                         xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M10.0001 18.8334C5.39758 18.8334 1.66675 15.1025 1.66675 10.5C1.66675 5.89752 5.39758 2.16669 10.0001 2.16669C14.6026 2.16669 18.3334 5.89752 18.3334 10.5C18.3334 15.1025 14.6026 18.8334 10.0001 18.8334ZM10.0001 17.1667C11.7682 17.1667 13.4639 16.4643 14.7141 15.2141C15.9644 13.9638 16.6667 12.2681 16.6667 10.5C16.6667 8.73191 15.9644 7.03622 14.7141 5.78598C13.4639 4.53573 11.7682 3.83335 10.0001 3.83335C8.23197 3.83335 6.53628 4.53573 5.28604 5.78598C4.03579 7.03622 3.33341 8.73191 3.33341 10.5C3.33341 12.2681 4.03579 13.9638 5.28604 15.2141C6.53628 16.4643 8.23197 17.1667 10.0001 17.1667V17.1667ZM5.83341 11.3334H13.3334V13H10.0001V15.5L5.83341 11.3334ZM10.0001 8.00002V5.50002L14.1667 9.66669H6.66675V8.00002H10.0001Z"
                            fill="url(#paint0_linear_1701:4472)"/>
                      <defs>
                        <linearGradient id="paint0_linear_1701:4472"
                                        x1="15.4825" y1="2.82015"
                                        x2="4.654" y2="18.0273"
                                        gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#F8B900"/>
                          <stop offset="1" stop-color="#E67508"/>
                        </linearGradient>
                      </defs>
                    </svg>
                    <span>GLOBAL COVERAGE</span>
                  </div>
                  <div class="body">
                    <p>Any currency over the globe supported</p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- BACKOFFICE BLOCK ========================================= END -->

      <!-- GIVE YOUR PLAYERS MORE BLOCK ================================= -->
      <ContactUs />
      <!-- GIVE YOUR PLAYERS MORE BLOCK ============================= END -->

      <!-- MAP BLOCK ==================================================== -->
      <!-- <BlockMap />-->
      <!-- MAP BLOCK ================================================ END -->

    </div>
  </main>
</template>


<script>
import BreadCrumbs from '@/components/breadcrumbs';
import MoveLine from '@/components/move_line';
import ContactUs from '@/components/contact_us';
import BlockMap from './block_map';


export default {
    name: 'About',
    components: {
        BreadCrumbs,
        MoveLine,
        ContactUs,
        BlockMap
    },
}
</script>

<style scoped>

</style>